'use client';

import { useState, useEffect, lazy, Suspense } from 'react';

// Lazy load the SpeedMeister component
const SpeedMeister = lazy(() => import('./SpeedMeister'));

export default function SpeedMeisterLoader() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Only load SpeedMeister after page is fully loaded and idle
    let timeoutId: NodeJS.Timeout;

    const loadSpeedMeister = () => {
      // Use requestIdleCallback if available, otherwise fallback to setTimeout
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => {
          setShouldLoad(true);
        }, { timeout: 3000 });
      } else {
        timeoutId = setTimeout(() => {
          setShouldLoad(true);
        }, 2000);
      }
    };

    // Wait for window load event to ensure everything is loaded
    if (document.readyState === 'complete') {
      loadSpeedMeister();
    } else {
      window.addEventListener('load', loadSpeedMeister);
    }

    return () => {
      window.removeEventListener('load', loadSpeedMeister);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  // Don't render anything until we're ready to load
  if (!shouldLoad) return null;

  return (
    <Suspense fallback={null}>
      <SpeedMeister />
    </Suspense>
  );
}